import { render } from "./YearTirePackage.vue?vue&type=template&id=026f478c&scoped=true"
import script from "./YearTirePackage.vue?vue&type=script&lang=js"
export * from "./YearTirePackage.vue?vue&type=script&lang=js"

import "./YearTirePackage.vue?vue&type=style&index=0&id=026f478c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026f478c"]])

export default __exports__